import { camelCase } from 'lodash';
import { object } from 'prop-types';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ApiImg, Icon, ProductsContext, SanitizedHtml } from 'components';
import { getSubTypeLogo } from 'helpers';
import { useUser } from 'hooks';

const TravelItem = ({ travel }) => {
  const { t } = useTranslation();
  const { goToProductSow } = useContext(ProductsContext);
  const { currentUser, isLaposteEmployee } = useUser();
  const showSubTypeLogo = useMemo(() => {
    /*
      TODO : Temporary condition to show the subType logo
      Remove this once the backend is ready to send the logo display condition

      -> Only LaPoste employees can see the Cogas logo
    */
    if (isLaposteEmployee && travel.typeItem === 1 && travel.subType === 'Cogas') {
      return true;
    }
    return false;
  }, [currentUser, travel]);

  return (
    <div className="product-item travel" onClick={() => goToProductSow(travel, 'travels')}>
      <div className="image-container">
        <div className="h-full w-full lg:aspect-square lg:h-[14.38rem] lg:rounded-xl lg:overflow-hidden">
          <ApiImg src={travel.vignette} width="116" height="200" />
        </div>
      </div>

      <div className="content-container">
        <div className="flex items-end justify-between gap-4 lg:mb-2">
          <h3 className="h3 truncate-line one-line">{travel.title}</h3>

          {showSubTypeLogo && getSubTypeLogo(travel.subType) && (
            <div className="aspect-video h-8">
              <img
                src={getSubTypeLogo(travel.subType)}
                alt={t(`alts.${camelCase(travel.subType)}`)}
                className="w-full h-full object-contain"
                width="57"
                height="32"
              />
            </div>
          )}
        </div>

        <div className="flex items-baseline gap-3 text-gray-600 text-sm lg:mb-2">
          <Icon name="location-dot" iconStyle="fad" classes="fa-swap-opacity" />
          {travel.subtitle}
        </div>

        {travel.resume && (
          <div className="content-text py-2 text-gray-600">
            <SanitizedHtml className="truncate-line four-lines" content={travel.resume} filterEmpty />
          </div>
        )}

        <div className="flex items-center flex-wrap gap-1 lg:mt-2">
          {t('fromPrice')} <span className="text-secondary-500">{travel.price} €</span>
        </div>
      </div>
    </div>
  );
};

TravelItem.propTypes = {
  travel: object.isRequired
};

export default TravelItem;
